"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedDate = void 0;
var _dateformat = _interopRequireDefault(require("dateformat"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var invalidDateMessage = 'invalid date';
var invalidLocaleMessage = 'invalid locale or date';
var invalidLocaleFormatMessage = 'invalid locale format';
var localeFormatFunctions = {
  time: Date.prototype.toLocaleTimeString,
  date: Date.prototype.toLocaleDateString,
  datetime: Date.prototype.toLocaleString
};
var invalidMessage = function invalidMessage(_ref) {
  var message = _ref.message,
    isErrorMessageHidden = _ref.isErrorMessageHidden;
  return isErrorMessageHidden ? '' : message;
};
var localeFormatConverter = function localeFormatConverter(jsDate, locale, localeFormat, isErrorMessageHidden) {
  try {
    return localeFormatFunctions[localeFormat] ? localeFormatFunctions[localeFormat].call(jsDate, locale) : invalidMessage({
      message: invalidLocaleFormatMessage,
      isErrorMessageHidden: isErrorMessageHidden
    });
  } catch (error) {
    console.error(error);
  }
  return invalidMessage({
    message: invalidLocaleMessage,
    isErrorMessageHidden: isErrorMessageHidden
  });
}; // eslint-disable-next-line no-restricted-globals

var isCorrectDate = function isCorrectDate(date) {
  return isFinite(date.valueOf());
};
var getFormattedDate = function getFormattedDate(_ref2) {
  var date = _ref2.date,
    dateFormat = _ref2.dateFormat,
    locale = _ref2.locale,
    localeFormat = _ref2.localeFormat,
    isErrorMessageHidden = _ref2.isErrorMessageHidden;
  var jsDate = new Date(date);
  if (!isCorrectDate(jsDate)) {
    return invalidMessage({
      message: invalidDateMessage,
      isErrorMessageHidden: isErrorMessageHidden
    });
  }
  return locale ? localeFormatConverter(jsDate, locale, localeFormat, isErrorMessageHidden) : (0, _dateformat.default)(jsDate, dateFormat);
}; // eslint-disable-line import/prefer-default-export

exports.getFormattedDate = getFormattedDate;